import { defineComponent as _defineComponent } from 'vue'
import { IImageUrls } from 'JS/types/Catalog';


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselCard',
  props: {
    id: null,
    title: null,
    href: null,
    rel: null,
    target: null,
    imageUrls: null
  },
  setup(__props: any) {

const props = __props as {
	id: string;
	title: string;
	href: string;
	rel?: string;
	target?: string;
	imageUrls: IImageUrls;
}



return { __sfc: true,props }
}

})